import { render } from "./CameraView.vue?vue&type=template&id=831f16f0&scoped=true"
import script from "./CameraView.vue?vue&type=script&lang=js"
export * from "./CameraView.vue?vue&type=script&lang=js"

import "./CameraView.vue?vue&type=style&index=0&id=831f16f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-831f16f0"]])

export default __exports__